
import CharacteristicBox from './CharacteristicBox.vue'

export default {
  components: {
    CharacteristicBox,
  },
  props: {
    characteristics: {
      type: Array,
      required: true,
    },
  },
}
